import { apiBaseAssets } from "../config/api";
import lc from "../utils/language";
import ScrollContainer from "react-indiana-drag-scroll";
import HorizontalScroll from "react-scroll-horizontal";
import React, { useState, useEffect, useRef } from "react";
import gsap from "gsap";

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  }, [matches, query]);

  return matches;
}

export const Services = ({ data, isRtl }) => {
  let scrl = useRef();
  const isDesktop = useMediaQuery('(min-width: 991px)');
  const [scrollX, setscrollX] = useState(0);
  const [scrolEnd, setscrolEnd] = useState(false);

  useEffect(() => {
    console.log('scrl', scrl)
  }, [scrl])

  //Slide click
  const slide = (shift) => {
    scrl.current.state.animValues += shift;
    // scrl.current.scrollLeft += shift;
    setscrollX(scrollX + shift);

    if (
      Math.floor(scrl.current.scrollWidth - scrl.current.state.animValues) <=
      scrl.current.offsetWidth
    ) {
      setscrolEnd(true);
    } else {
      setscrolEnd(false);
    }
    // console.log('scrl.current.state.animValues', scrl.current.state.animValues)
  };

  const anim = (e) => {
    gsap.from(e.target, { scale: 1 });
    gsap.to(e.target, { scale: 1.5 });
  };
  const anim2 = (e) => {
    gsap.from(e.target, { scale: 1.5 });
    gsap.to(e.target, { scale: 1 });
  };

  return (
    <div id="services" style={{ background: 'none' }}>
      <div className="container" style={{ background: 'none' }}>
        <div className="section-title" style={{ background: 'none', textAlign: 'center' }}>
          <h2 style={{ fontFamily: isRtl ? "amiriBold" : "Merriweather", }}>
            {data[lc("title", isRtl)]}
          </h2>
          <p style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans", color: '#7FB6FF' }}>
            {data[lc("subTitle", isRtl)]}
          </p>
        </div>
        <div className="row">
          {/* {data.services.length > 0
            ? data.services.map((d, i) => (
              <div key={d._id} className="col-md-4">
                <div className="feature-image-wrapper">
                  <img
                    src={`${apiBaseAssets}${d.background}`}
                    className="feature-image"
                  />
                </div>
                <div className="service-desc">
                  <h3
                    style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans" }}
                  >
                    {d[lc("title", isRtl)]}
                  </h3>
                  <p
                    style={{
                      fontFamily: isRtl ? "amiriRegular" : "Open Sans",
                    }}
                  >
                    {d[lc("subTitle", isRtl)]}
                  </p>
                </div>
              </div>
            ))
            : "loading"} */}
          {
            isDesktop ? <div
              style={{
                width: "100%",
                // display: "flex",
                // flexDirection: "column",
                // justifyContent: "flex-start",
                // // gap: "10px",
                position: 'relative'
              }}
            >
              {
                data?.services?.length > 5 ? <>
                  {!scrolEnd && (
                    // <button
                    // onClick={() => slide(-300)}
                    // onMouseEnter={(e) => anim(e)}
                    // onMouseLeave={(e) => anim2(e)}
                    // style={{ position: 'absolute', top: '100px', left: '100%', zIndex: 2, backgroundColor: 'transparent' }}><img src="img/Vector.png" /></button>
                    <img src="img/Vector.png"
                      onClick={() => slide(-300)}
                      onMouseEnter={(e) => anim(e)}
                      onMouseLeave={(e) => anim2(e)}
                      style={{ position: 'absolute', top: '100px', left: '105%', zIndex: 2, }} />
                  )}
                  {scrollX !== 0 && (
                    // <button
                    //   onClick={() => slide(+300)}
                    //   onMouseEnter={(e) => anim(e)}
                    //   onMouseLeave={(e) => anim2(e)}
                    //   style={{ position: 'absolute', top: '100px', left: -5, zIndex: 2, }}>test</button>
                    <img src="img/Vector1.png" onClick={() => slide(+300)}
                      onMouseEnter={(e) => anim(e)}
                      onMouseLeave={(e) => anim2(e)}
                      style={{ position: 'absolute', top: '100px', left: '-5%', zIndex: 2, }} />
                  )}
                </> : null
              }
              {
                // !smScreen ? <ScrollContainer
                //   className={classes.scrollContainer}
                //   style={{
                //     cursor: "grab",
                //     width: `100%`, height: `190px`,
                //     direction: 'rtl'
                //   }}
                // >
                //   <div
                //     className={classes.root2}
                //     style={{ position: "initial", paddingBottom: "1rem", }}
                //   >
                //     {data?.services?.map((item) => (
                //       <div key={item?.id} className={classes.partnerCard}>
                //         <img
                //           onClick={() => navigate('/pictures')}
                //           key={item?.id}
                //           src={item?.icon}
                //           style={{
                //             width: "100%",
                //             height: "100%",
                //             objectFit: "cover",
                //             borderRadius: '8px'
                //           }}
                //         />
                //       </div>
                //     ))}
                //   </div>
                // </ScrollContainer>
                //   :
                data?.services?.length > 5 ?
                  <HorizontalScroll
                    pageLock={true}
                    reverseScroll={true}
                    style={{
                      width: `100%`, height: `400px`,/* paddingBottom: '1rem'*/
                      direction: 'ltr',

                    }}
                    // className={classes.horizontalScroll}
                    ref={scrl}
                  >
                    {/* <div
                      // className={classes.root}
                      style={{
                        // transition: 'all 1s ease',
                        position: "initial", paddingBottom: "1rem", paddingBottom: '1rem',
                        width: '100%',
                        height: '400px',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '30px',
                        overflow: 'scroll',
                        overflowY: 'hidden',
                        direction: 'rtl',
                        padding: '1rem',
                        paddingLeft: '15rem',
                        paddingRight: '15rem'
                      }}
                      ref={scrl}
  
                    > */}
                    {data?.services?.length > 0
                      ? data?.services?.map((d, i) => (
                        <div key={d._id} className="col-md-4">
                          <div className="feature-image-wrapper">
                            <img
                              src={`${apiBaseAssets}${d.background}`}
                              className="feature-image"
                            />
                          </div>
                          <div className="service-desc">
                            <h3
                              style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans", color: '#fff' }}
                            >
                              {d[lc("title", isRtl)]}
                            </h3>
                            <p
                              style={{
                                fontFamily: isRtl ? "amiriRegular" : "Open Sans", color: 'rgba(242, 242, 242,0.7)'
                              }}
                            >
                              {d[lc("subTitle", isRtl)]}
                            </p>
                          </div>
                        </div>
                      ))
                      : "loading"}
                    {/* </div> */}
                  </HorizontalScroll>
                  :
                  <div
                    style={{
                      position: "initial", paddingBottom: "1rem", paddingBottom: '1rem',
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                      // justifyContent: 'center',
                      alignItems: 'center',
                      gap: '30px',
                      // overflow: 'scroll',
                      overflowY: 'hidden',
                      direction: 'rtl',
                      padding: '1rem',
                    }}
                    className="justi"
                  >
                    {data.services.length > 0
                      ? data.services.map((d, i) => (
                        <div key={d._id} className="col-md-4" style={{ height: '240px' }}>
                          <div className="feature-image-wrapper">
                            <img
                              src={`${apiBaseAssets}${d.background}`}
                              className="feature-image"
                            />
                          </div>
                          <div className="service-desc">
                            <h3
                              style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans", color: '#fff', textOverflow: 'ellipsis' }}
                            >
                              {d[lc("title", isRtl)]}
                            </h3>
                            <p
                              style={{
                                fontFamily: isRtl ? "amiriRegular" : "Open Sans", color: 'rgba(242, 242, 242,0.7)', textOverflow: 'ellipsis'
                              }}
                            >
                              {d[lc("subTitle", isRtl)]}
                            </p>
                          </div>
                        </div>
                      ))
                      : "loading"}
                  </div>
              }
            </div > :
              <div style={{ display: 'flex', width: '100%', flexWrap: 'wrap', gap: '10px', justifyContent: 'center' }}>
                {data?.services?.length > 0
                  ? data?.services?.map((d, i) => (
                    <div key={d._id} className="col-md-4" style={{ textAlign: 'center' }}>
                      <div className="feature-image-wrapper">
                        <img
                          src={`${apiBaseAssets}${d.background}`}
                          className="feature-image"
                        />
                      </div>
                      <div className="service-desc">
                        <h3
                          style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans", color: '#fff' }}
                        >
                          {d[lc("title", isRtl)]}
                        </h3>
                        <p
                          style={{
                            fontFamily: isRtl ? "amiriRegular" : "Open Sans", color: 'rgba(242, 242, 242,0.7)'
                          }}
                        >
                          {d[lc("subTitle", isRtl)]}
                        </p>
                      </div>
                    </div>
                  ))
                  : "loading"}
              </div>
          }

        </div>
      </div>
    </div>
  );
};
